// import './styles/common.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import DiamondMesh from './DiamondMesh.jsx'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    <Canvas
        camera={ {
            fov: 45,
            near: 0.1,
            far: 200,
            position: [ 0, 2, 5 ]
        } }
    >
        <DiamondMesh />
        <Experience />
    </Canvas>
)